// src/lib/useBadgeTally.tsx
import React, { createContext, useContext, useMemo, useState } from "react";

type BadgeState = {
  messages: number;
  offers: number;
};

type Ctx = {
  badges: BadgeState;
  setBadges: (next: Partial<BadgeState>) => void;
};

const BadgeCtx = createContext<Ctx | null>(null);

export function BadgeProvider({ children }: { children: React.ReactNode }) {
  const [badges, setBadgesState] = useState<BadgeState>({ messages: 0, offers: 0 });
  const ctx = useMemo<Ctx>(
    () => ({
      badges,
      setBadges: (next) => {
        setBadgesState((prev) => ({
          messages: next.messages ?? prev.messages,
          offers: next.offers ?? prev.offers,
        }));
      },
    }),
    [badges],
  );
  return <BadgeCtx.Provider value={ctx}>{children}</BadgeCtx.Provider>;
}

export function useBadgeTally() {
  const ctx = useContext(BadgeCtx);
  if (!ctx) throw new Error("useBadgeTally must be used within <BadgeProvider>");
  return ctx;
}

